module.exports = __webpack_public_path__ + "static/media/locked-exam.86575d33.svg";